import { BaseDecoratorOptions } from '../types';
import { applyDecorators } from '@nestjs/common';
import { Transform } from 'class-transformer';
import { ApiPropertyString } from './string.decorator';
import { isDefined } from 'class-validator';

type PropertyBigintParams = BaseDecoratorOptions<string>;

export function ApiPropertyBigint(
  params: PropertyBigintParams = {},
): PropertyDecorator {
  return applyDecorators(
    Transform(({value}) => isDefined(value) ? value.toString() : value),
    ApiPropertyString(params)
  );
}
